import { errorMessages } from "../../constants";
import type { EventBuilder } from "../../typings";

import { buildBasePulseEvent } from "./baseEvent";

export const buildConversionEvent: EventBuilder = (input) => {
  const { eventKey, userAttributes } = input;
  if (!eventKey) throw new Error(errorMessages.NO_EVENT_KEY);

  return {
    "@type": "Convert",
    object: {
      "@type": "ExperimentCustomConversion",
      attrs: JSON.stringify(userAttributes),
      customKey: eventKey,
      ...(input.eventTags && { eventTags: JSON.stringify(input.eventTags) }),
    },
    ...buildBasePulseEvent(input),
  };
};
